/*
 * @Description:
 * @Version: 2.0
 * @Autor: shimnx
 * @Date: 2021-08-04 09:07:37
 * @LastEditors: shimnx
 * @LastEditTime: 2022-07-22 09:51:12
 */
import { NgModule } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Routes, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { PageNotFoundComponent } from './result/404/page-not-found.component';
import { NoPermissionComponent } from './result/401/no-permission.component';

import { TokenComponent } from './token/token.component';
const routes: Routes = [
  {
    path: 'pages',
    loadChildren: () => import('./pages/pages.module').then((m) => m.PagesModule)
  },
  {
    path: '',
    redirectTo: 'pages',
    pathMatch: 'full'
  },

  {
    path: 'token',
    component: TokenComponent
  },
  {
    path: '401',
    component: NoPermissionComponent
  }
  // {
  //     path: '**',
  //     component: PageNotFoundComponent
  // },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true }), CommonModule],
  exports: [RouterModule]
})
export class AppRoutingModule {}
